import { FullWidthButton } from "../../../../../components/buttons/FullWidthButton";
import { ReactComponent as IconEmail } from "../../../../../../src/assets/icons/circle-envelope-solid.svg";
import { event } from "../../../../../events/core/helpers";
import { ButtonPress } from "../../../../../events/event-types/common/ButtonPress";
import { EventSubCategories } from "../../../../../events/event-sub-categories";

export type Props = {
  onChoose?: () => any;
};

function Choose(props: Props) {
  const { onChoose = () => {} } = props;

  return (
    <div
      style={{
        width: `100%`,
      }}
    >
      <FullWidthButton
        contentTop={`Sign in with Email`}
        type={`secondary-white`}
        iconLeft={
          <IconEmail
            style={{
              height: `20px`,
              width: `20px`,
            }}
          />
        }
        onClick={() => {
          event(
            new ButtonPress({
              buttonName: `Sign in with Email`,
              buttonSlug: `SIGN_IN_WITH_EMAIL`,
              subCategory: EventSubCategories.AUTH,
            })
          );

          onChoose();
        }}
      />
    </div>
  );
}

export { Choose };
